<textarea type="text" name="{{name}}" class="form-control form-control-solid mentions-field" required #expressionTextarea
  placeholder="Press CTRL+SPACE to search..." rows="10" cols="50" style="height: 100px;"
  (keydown)="onKeyDown($event)"
  [(ngModel)]="expression" (ngModelChange)="onExpressionChanged()"
  [mention]="mentionItems"
  [mentionConfig]="mentionConfig"
  (searchTerm)="onMentionSearch($event)"
  (itemSelected)="onItemSelected()"
  (opened)="onMenuShown()" (closed)="onMenuHidden()"
  [ngClass]="{'is-invalid' : expressionBeingEdited && expressionBeingEdited.touched && expressionBeingEdited.invalid}" #expressionBeingEdited="ngModel">
</textarea>
